import PropTypes from 'prop-types';
import SVG from '@activebrands/core-web/components/SVG';

const MenuIcon = ({ color, width = '24px', height = 'auto', ...rest }) => (
    <SVG fill="none" height={height} viewBox="0 0 24 24" width={width} xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path d="M0 18h24" stroke={color} />
        <path d="M0 12h16" stroke={color} />
        <path d="M0 6h24" stroke={color} />
    </SVG>
);

MenuIcon.propTypes = {
    $style: PropTypes.object,
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
};

MenuIcon.defaultProps = {
    $style: {},
    color: 'currentColor',
    height: '16px',
    width: '100%',
};

export default MenuIcon;
